"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReferenceLinkSchema = void 0;
exports.ReferenceLinkSchema = {
    "$id": "https://www.redbull.com/schemas/attributes/reference-link.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "ReferenceLink",
    "description": "Link to another content resource",
    "type": "object",
    "additionalProperties": false,
    "properties": {
        "type": {
            "type": "string",
            "enum": [
                "attributes:reference-link"
            ]
        },
        "markup": {
            "type": "array",
            "items": {
                "type": "string",
                "enum": [
                    "emphasized"
                ]
            }
        },
        "reference": {
            "anyOf": [
                {
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/reference/content/collections.schema.json"
                },
                {
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/reference/content/energy-drinks.schema.json"
                },
                {
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/reference/content/episode-videos.schema.json"
                },
                {
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/reference/content/event-profiles.schema.json"
                },
                {
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/reference/content/event-series.schema.json"
                },
                {
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/reference/content/externals.schema.json"
                },
                {
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/reference/content/films.schema.json"
                },
                {
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/reference/content/image-galleries.schema.json"
                },
                {
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/reference/content/images.schema.json"
                },
                {
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/reference/content/judges.schema.json"
                },
                {
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/reference/content/live-videos.schema.json"
                },
                {
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/reference/content/locations.schema.json"
                },
                {
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/reference/content/partner-profiles.schema.json"
                },
                {
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/reference/content/person-profiles.schema.json"
                },
                {
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/reference/content/photographers.schema.json"
                },
                {
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/reference/content/project-profiles.schema.json"
                },
                {
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/reference/content/rally-drivers.schema.json"
                },
                {
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/reference/content/rally-teams.schema.json"
                },
                {
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/reference/content/recap-videos.schema.json"
                },
                {
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/reference/content/shows.schema.json"
                },
                {
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/reference/content/stories.schema.json"
                },
                {
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/reference/content/tags.schema.json"
                },
                {
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/reference/content/team-profiles.schema.json"
                },
                {
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/reference/content/trailer-videos.schema.json"
                },
                {
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/reference/content/tv-commercials.schema.json"
                },
                {
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/reference/content/videos.schema.json"
                },
                {
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/reference/content/videos-360.schema.json"
                }
            ]
        },
        "text": {
            "type": "string"
        }
    },
    "required": [
        "reference",
        "text",
        "type"
    ]
};
//# sourceMappingURL=data:application/json;base64,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